import { useTranslations } from '@vocab/react';
import { Dialog } from 'braid-design-system';
import type React from 'react';

import translations from './.vocab';
import { JobInformationContent } from './JobInformationContent';

interface UnloadedJobInformation {
  jobId: string;
}

interface JobInformationDialogProps {
  jobInformation: UnloadedJobInformation;
  open: boolean;
  onClose(): void;
}

export const JobInformationDialog: React.FC<
  React.PropsWithChildren<JobInformationDialogProps>
> = ({ jobInformation, open, onClose }) => {
  const { t } = useTranslations(translations);

  return (
    <Dialog
      id="job-information"
      title={t('Job information')}
      width="medium"
      open={open}
      onClose={onClose}
    >
      {open && <JobInformationContent jobId={jobInformation.jobId} />}
    </Dialog>
  );
};
